import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid } from "@material-ui/data-grid";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
import { DatePicker, Button } from "antd";
import dayjs from "dayjs";

import Modal from "../../../components/Modal/Modal";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";

import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

import PrintButton from "./PrintButton";
import { toast } from "react-hot-toast";
import MemberOutstandingPaymentChild from "./MemberOutstandingPaymentsChild";
import {
  HiOutlineCash,
  HiOutlineDocumentText,
  HiOutlineChartBar,
  HiFilter,
  HiRefresh,
} from "react-icons/hi";

const MemberPaymentDuesChild = () => {
  let navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [userData, setUserData] = useState(null);
  const toggleModal = () => {
    setShowModal(!showModal);
  };

  //Error Logging Service
  const [{ errorLogApi, user }] = useAtom(gbState);
  // get user details
  // console.log(user);
  useEffect(() => {
    let userToken = localStorage.getItem("token");
    let urlLink = "";
    if (user?.role === "CHURCH_ADMIN")
      urlLink = `${process.env.REACT_APP_API_URL}/user/${user?._id}`;
    else
      urlLink = `${process.env.REACT_APP_API_URL}/family/primaryMember/${user?._id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        if (user?.user?.role === "CHURCH_ADMIN") {
          const oldData = response?.data?.users;
          setData(oldData);
        } else {
          const oldData = response.data.families;
          setUserData(oldData[0]);
        }
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  }, [user]);
  // console.log(userData);
  const getDataFromServer = () => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/receipt/overall_receipt/${user?._id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        // console.log(JSON.stringify(response.data.users)); return;
        const oldData = response.data.receipts;
        const updatedData = oldData.map((data) => {
          return {
            ...data,
            id: data?._id,
          };
        });

        setData(updatedData);
        setFilteredData([]);
        setIsFiltered(false);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/receipt/overall_receipt/${user?._id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then(function (response) {
          //console.log(JSON.stringify(response.data.users)); return;

          const oldData = response.data.receipts;
          const updatedData = oldData.map((data) => {
            return {
              ...data,
              id: data?._id,
            };
          });

          setData(updatedData);
          setFilteredData([]);
          setIsFiltered(false);
        })
        .catch(function (err) {
          console.log("error api call ", err);
        });
    };

    getDataFromServer();
  }, []);

  // Date range filter functions
  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
  };

  const applyDateFilter = () => {
    if (dateRange[0] && dateRange[1]) {
      const startDate = dateRange[0].startOf("day");
      const endDate = dateRange[1].endOf("day");

      const filtered = data.filter((payment) => {
        const paymentDate = dayjs(payment.paid_upto_date);
        return paymentDate.isAfter(startDate) && paymentDate.isBefore(endDate);
      });

      setFilteredData(filtered);
      setIsFiltered(true);
    }
  };

  const resetFilter = () => {
    setDateRange([null, null]);
    setFilteredData([]);
    setIsFiltered(false);
  };

  const editPaymentReceipts = (row) => {
    if (parseInt(row?.payment_status) === 1) {
      toast.error("The Payment is already settled");
      return;
    }
    // navigate("/receipt/update", {
    //   state: { receipt: row, subRecord: subscriberRecord },
    // });
  };

  const dateConvertUnixTime = (unixTimestamp) => {
    // Create a new date object from the Unix timestamp
    var date = new Date(unixTimestamp);

    // Convert the date to IST by adding the time difference
    // IST is UTC+5:30, so add 5 hours and 30 minutes to UTC time
    var istOffset = 5.5 * 60 * 60 * 1000; // Convert 5.5 hours to milliseconds
    var istDate = new Date(date.getTime() + istOffset);

    // Extract the date parts
    var day = istDate.getDate();
    var month = istDate.getMonth() + 1; // Months are zero-based in JavaScript
    var year = istDate.getFullYear();

    // Pad the day and month with a leading zero if they are less than 10
    day = day < 10 ? "0" + day : day;
    month = month < 10 ? "0" + month : month;

    // Return the formatted IST date
    return day + "-" + month + "-" + year;
  };

  const paymentStatusOption = ["Pending", "Settled", "Declined"];
  const statusTxtColor = ["text-white", "text-gray-800", "text-white"];
  const statusBgColor = ["bg-orange-400", "bg-green-400", "bg-red-400"];
  const columns = [
    {
      field: "Action",
      headerName: "Action",
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      width: 80,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="flex flex-row">
            <Tooltip title="Print View">
              <div
                onClick={() => {
                  if (params.row?.payment_status === 0) {
                    toast.error(
                      "Pending payment needs to be verified by admin"
                    );
                  } else {
                    setCurrentRecord(params.row);
                    toggleModal();
                  }
                }}
              >
                <i
                  className="cursor-pointer mdi mdi-cloud-print-outline"
                  style={{ fontSize: "18px", color: "black" }}
                ></i>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "financial_year",
      headerName: "Year",
      width: 90,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => params.row.financial_year.trim(),
    },
    {
      field: "receipt_no",
      headerName: "Receipt Code",
      width: 120,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "monthly_subscription",
      headerName: "Month Subscription",
      width: 160,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "payment_months",
      headerName: "Dues",
      width: 80,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "paid_upto_date",
      headerName: "Paid Upto",
      width: 100,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => dateConvertUnixTime(params.row.paid_upto_date),
    },
    {
      field: "payment_amount",
      headerName: "Amount",
      width: 100,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      width: 100,
      align: "center",
      field: "payment_status",
      headerName: "Status",
      renderCell: (params) => (
        <span
          className={`inline-block px-2 py-1 text-xs font-semibold ${
            params.row.payment_status >= 0 &&
            statusBgColor[parseInt(params.row.payment_status)]
          } ${
            params.row.payment_status >= 0 &&
            statusTxtColor[parseInt(params.row.payment_status)]
          } rounded-full`}
        >
          &nbsp;&nbsp;
          {params.row.payment_status >= 0 &&
            paymentStatusOption[parseInt(params.row.payment_status)]}
          &nbsp;&nbsp;
        </span>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="space-y-6">
          {/* Header Section */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="p-2 rounded-lg bg-blue-50">
                <HiOutlineCash className="w-6 h-6 text-blue-600" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">
                  Payment Dashboard
                </h1>
                <p className="mt-1 text-sm text-gray-500">
                  View and manage your payment details
                </p>
              </div>
            </div>
          </div>

          {/* Content Grid */}
          <div className="grid grid-cols-1 gap-6">
            {/* Outstanding Payment Card */}
            <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
              <div className="flex items-center mb-4 space-x-2">
                <HiOutlineDocumentText className="w-5 h-5 text-gray-400" />
                <h2 className="text-lg font-medium text-gray-900">
                  Outstanding Summary
                </h2>
              </div>
              <MemberOutstandingPaymentChild />
            </div>

            {/* Payment History Card */}
            <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                  <HiOutlineChartBar className="w-5 h-5 text-gray-400" />
                  <h2 className="text-lg font-medium text-gray-900">
                    Payment History
                  </h2>
                </div>

                {/* Date Range Filter */}
                <div className="flex items-center space-x-2">
                  <div className="flex items-center h-10 p-2 bg-white border border-gray-200 rounded-lg shadow-sm">
                    <HiFilter className="w-5 h-5 mr-2 text-indigo-500" />
                    <DatePicker.RangePicker
                      value={dateRange}
                      onChange={handleDateRangeChange}
                      format="MM-DD-YYYY"
                      className="h-full border-0 shadow-none"
                      placeholder={["Start date", "End date"]}
                      size="middle"
                    />
                  </div>
                  <div className="flex space-x-2">
                    <Button
                      type="primary"
                      onClick={applyDateFilter}
                      disabled={!dateRange[0] || !dateRange[1]}
                      className="flex items-center justify-center h-10 px-4 text-white bg-indigo-500 border-0 rounded-md shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      Apply Filter
                    </Button>
                    {isFiltered && (
                      <Button
                        onClick={resetFilter}
                        className="flex items-center justify-center h-10 px-4 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      >
                        <HiRefresh className="w-4 h-4 mr-1" />
                        Reset
                      </Button>
                    )}
                  </div>
                </div>
              </div>

              {/* Filter Status Message */}
              {isFiltered && (
                <div className="p-2 mb-4 rounded-md bg-indigo-50">
                  <p className="text-sm text-indigo-700">
                    {filteredData.length === 0
                      ? "No payments found within the selected date range"
                      : `Showing ${
                          filteredData.length
                        } payments from ${dateRange[0].format(
                          "MMMM DD, YYYY"
                        )} to ${dateRange[1].format("MMMM DD, YYYY")}`}
                  </p>
                </div>
              )}

              <div className="border border-gray-200 rounded-lg">
                <DataGrid
                  rows={isFiltered ? filteredData : data}
                  disableSelectionOnClick
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                  displayTitle="Income List"
                  style={{
                    height: "40vh",
                    border: "none",
                    backgroundColor: "white",
                    "& .MuiDataGrid-cell": {
                      borderBottom: "1px solid #f3f4f6",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#f9fafb",
                      borderBottom: "1px solid #e5e7eb",
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ErrorBoundaryRoutes route="/users" page="ModalView">
        {showModal && (
          <Modal onClose={toggleModal}>
            {/* <h2 className="mb-4 text-xl font-bold"></h2> */}
            <PrintButton
              currentRecord={currentRecord}
              subscriberRecord={user}
            />
          </Modal>
        )}
      </ErrorBoundaryRoutes>
    </div>
  );
};

export default MemberPaymentDuesChild;
